import { map, isEmpty } from 'lodash';

import PROPERTIES from './properties.rules';

export const ERRORS = {
  NON_OF_PROPERTIES_IS_VALID: 'NON_OF_PROPERTIES_IS_VALID',
};

const correctEventProperty = (name, valueSource) => {
  const validationRule = PROPERTIES[name];
  let value = valueSource

  if (!validationRule) {
    // TODO: Logging out an error or warning to notice that this properties is not listed yet in validation rules. Error message `No validation rule found for ${name} property`
    return value;
  }

  if (validationRule.transformValue) {
    map(validationRule.transformValue, (rule) => {
      const { fromRegex, toValue } = rule;
      const fromRegexObj = new RegExp(fromRegex);
      if (fromRegexObj.test(value)) {
        value = toValue;
      }
    });
  }

  switch (validationRule.type) {
    case 'string':
      if (
        value === null ||
        value === undefined ||
        (typeof value === 'string' && !value.length) ||
        typeof value === 'object' ||
        typeof value === 'symbol' ||
        value === '[]' ||
        value === '{}'
      ) {
        return null;
      }
      return validationRule.canBeUppercase
        ? String(value)
        : String(value).toLowerCase();
    case 'int':
      if (typeof value !== 'number' && Number.isNaN(parseInt(value, 10))) {
        return null;
      }
      return parseInt(value, 10);
    case 'boolean':
      if (typeof value !== 'boolean' && ['true', 'false'].indexOf(value) < 0) {
        return null;
      }
      return value === 'false' ? false : !!value;
    case 'enum':
      // eslint-disable-next-line no-case-declarations
      const lowerCaseValue = String(value).toLowerCase();
      if (validationRule.validValues.indexOf(lowerCaseValue) > -1) {
        return lowerCaseValue;
      }
      return null;
    default:
      return null;
  }
};

const correctEventProperties = (properties) => {
  const validEventProperties = {};
  map(properties, (value, key) => {
    const correctedValue = correctEventProperty(key, value);
    if (correctedValue !== null) {
      validEventProperties[key] = correctedValue;
    }
  });
  return validEventProperties;
};

export const eventCorrector = (properties) => {
  let correctedProperties = {};
  correctedProperties = correctEventProperties(properties);

  if (isEmpty(correctedProperties)) {
    return [ERRORS.NON_OF_PROPERTIES_IS_VALID, {}];
  }
  return [null, correctedProperties];
};
